const CHUNK_LOAD_FAILURE = /dynamically imported module|loading chunk|chunkloaderror|importing a module script failed/i;

/** True when a navigation failed because the page file could not be downloaded. */
export function isChunkLoadFailure(error: unknown): boolean {
  return CHUNK_LOAD_FAILURE.test(readErrorText(error));
}

function readErrorText(error: unknown): string {
  if (error instanceof Error) {
    const cause = 'cause' in error ? readErrorText(error.cause) : '';
    return `${error.name} ${error.message} ${cause}`;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as {message?: unknown}).message;
    return typeof message === 'string' ? message : '';
  }
  return '';
}
